import { render, staticRenderFns } from "./ProductWithOptionsSearchPopupIframe.vue?vue&type=template&id=9049d6b4&"
import script from "./ProductWithOptionsSearchPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductWithOptionsSearchPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports